/**
 * BattlVault page gate — allow only Recharge-active subscribers.
 * Used on partner discounts + exclusive-product-battlvault collection.
 */
(function () {
  if (window.__battlvaultSubscriberGateInit) return;
  window.__battlvaultSubscriberGateInit = true;

  var WAIT_ATTEMPTS = 80;
  var TIMEOUT_MS = 12000;
  var DENY_URL = '/pages/public-landing-page';

  function withTimeout(promise, message) {
    return Promise.race([
      promise,
      new Promise(function (_, reject) {
        setTimeout(function () {
          reject(new Error(message || 'Request timed out.'));
        }, TIMEOUT_MS);
      })
    ]);
  }

  function waitForRecharge(attemptsLeft) {
    if (window.recharge && typeof window.recharge.init === 'function') {
      return Promise.resolve(window.recharge);
    }
    if (attemptsLeft <= 0) {
      return Promise.reject(new Error('Unable to load Recharge.'));
    }
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        waitForRecharge(attemptsLeft - 1).then(resolve).catch(reject);
      }, 100);
    });
  }

  function isActiveSubscription(subscriptions) {
    var list = Array.isArray(subscriptions) ? subscriptions : [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i] && list[i].status || '').toLowerCase() === 'active') {
        return true;
      }
    }
    return false;
  }

  function themeSaysActive() {
    if (window.subscriber_status === 'active') return true;
    var tags = window.theme && window.theme.customerTags;
    return Array.isArray(tags) && tags.indexOf('Active Subscriber') > -1;
  }

  function allow(root) {
    root.remove();
  }

  function deny(root) {
    var url = root.getAttribute('data-redirect-url') || DENY_URL;
    window.location.replace(url);
  }

  function start() {
    var root = document.querySelector('[data-battlvault-subscriber-gate]');
    if (!root) return;

    var configEl = root.querySelector('[data-battlvault-subscriber-gate-config]');
    var config = {};
    try {
      config = JSON.parse(configEl && configEl.textContent || '{}');
    } catch (e) {
      deny(root);
      return;
    }

    var token = config.storefrontAccessToken;
    if (!token || !String(token).trim()) {
      themeSaysActive() ? allow(root) : deny(root);
      return;
    }

    waitForRecharge(WAIT_ATTEMPTS)
      .then(function (recharge) {
        recharge.init({
          storeIdentifier: config.storeIdentifier,
          storefrontAccessToken: token,
          appName: 'battlbox-battlvault-gate',
          appVersion: '1.0.0',
          loginRetryFn: function () {
            return recharge.auth.loginShopifyAppProxy();
          }
        });

        return withTimeout(
          recharge.auth.loginShopifyAppProxy(),
          'Unable to verify subscription status.'
        );
      })
      .then(function (session) {
        var customerId = session && (session.customerId || session.customer_id);
        if (!customerId) return false;

        return withTimeout(
          window.recharge.subscription.listSubscriptions(session, {
            limit: 50,
            sort_by: 'id-desc'
          }),
          'Unable to load subscriptions.'
        ).then(function (response) {
          var subscriptions = (response && response.subscriptions) || [];
          return isActiveSubscription(subscriptions);
        });
      })
      .then(function (isActive) {
        isActive ? allow(root) : deny(root);
      })
      .catch(function () {
        themeSaysActive() ? allow(root) : deny(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
